import React from "react";

export default function ButtonInside(props) {
  const { btnText, btnHandler, idx, filterType, name, flag } = props;

  const handleClick = () => {
    btnHandler(btnText, !flag);
  };

  return (
    <p
      onClick={(e) => {
        handleClick();
      }}
    >
      {btnText}
    </p>
  );
}
